var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarShine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 148,
    viewBox: "0 0 149 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1396_8496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 149,
    height: 148
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 148,
    height: 148,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1396_8496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.361 111.048L115.248 96.8167L119.494 92.5709L133.724 106.683L129.361 111.048ZM109.65 39.3002L105.405 35.0544L119.517 20.9435L123.882 25.1878L109.65 39.3002ZM39.3505 39.4189L25.2381 25.1878L29.4838 20.9435L43.7149 35.0544L39.3505 39.4189ZM19.5216 111.048L15.2773 106.683L29.3882 92.5709L33.7527 96.8167L19.5216 111.048ZM49.6211 110.277L74.5005 95.3583L99.4986 110.55L92.9881 82.3019L114.844 63.4689L86.0506 60.8727L74.5005 34.2127L63.069 60.7185L34.2753 63.196L56.1315 82.3019L49.6211 110.277ZM40.2169 123.333L49.2881 84.6375L19.0005 58.4646L58.8942 55.0853L74.5005 18.5L90.2255 55.0853L130.119 58.4646L99.8316 84.6375L108.903 123.333L74.5005 102.734L40.2169 123.333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarShine);
export default __webpack_public_path__ + "static/media/star_shine.6241fcb01babccd501850fe8406d36ca.svg";
export { ForwardRef as ReactComponent };